export default () => ({
    // Refresh the CSRF token on form init due to Fast CGI Cache
    // Docs: https://verbb.io/craft-plugins/formie/docs/template-guides/cached-forms
    async init() {
        const self = this;

        const csrfTokenName = document.querySelector('meta[name="csrf-token-name"]').content;
        const formieFormHandle = self.$root.querySelector('input[name=handle]').value;

        const csrfInputField = self.$root.querySelector('input[name=' + csrfTokenName + ']');

        csrfInputField.value = await getCSRFToken(formieFormHandle);
    }
});

const getCSRFToken = async (formHandle) => {
    const response = await fetch(`/actions/formie/forms/refresh-tokens?form=${formHandle}`);
    const json = await response.json();
    return json.csrf.token;
}